module.exports = __webpack_public_path__ + "static/media/twitter.ca15c3b9.svg";